module.exports = __webpack_public_path__ + "media/images/athletes/2830-e906cf020169072c87183a0922568e40.png";